// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"c75c4b91","398":"f45f3920","453":"fc323a1a","681":"1a392c32","715":"5d055bba","812":"ed6e5fa1"}[chunkId] + ".chunk.js";
};